import * as React from 'react';
import { IconProps } from '../types';

const IcSMS = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M2.624 1.882 22.86 12 2.624 22.118v-8.132L5.404 12l-2.78-1.985V1.882ZM7.444 13l-2.82 2.015v3.867L16.388 13H7.444Zm8.944-2H7.444l-2.82-2.014V5.117L16.388 11Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcSMS;
